module.exports = __webpack_public_path__ + "static/media/comp-pelletizing-s.a2c8ff28.jpg";